import { endPoints } from '../../utils/apiEndpoints';
import axios from '../../redux/axiosInterceptor'

export function requestStartRevPennyDrop() {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.reversePennyDrop,
  })
}

export function requestRevPennyDropStatus() {
  return axios.request({
    method: 'get',
    baseURL: endPoints.base,
    url: `${endPoints.reversePennyDrop}`,
  })
}
